"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryBrowserEncryptionProvider = void 0;

var _constants = require("@basis-theory/basis-theory-js-encryption/common/constants");

var _BasisTheoryBrowserAesEncryptionService = require("./BasisTheoryBrowserAesEncryptionService");

var _LocalStorageKeyRepository = require("./common/LocalStorageKeyRepository");

var _LocalStorageProviderKeyRepository = require("./common/LocalStorageProviderKeyRepository");

var _BrowserAesEncryptionFactory = require("./factories/BrowserAesEncryptionFactory");

var _BrowserAesProviderKeyFactory = require("./factories/BrowserAesProviderKeyFactory");

var _BrowserRsaEncryptionFactory = require("./factories/BrowserRsaEncryptionFactory");

var _BrowserRsaProviderKeyFactory = require("./factories/BrowserRsaProviderKeyFactory");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BasisTheoryBrowserEncryptionProvider = /*#__PURE__*/function () {
  function BasisTheoryBrowserEncryptionProvider() {
    _classCallCheck(this, BasisTheoryBrowserEncryptionProvider);

    _defineProperty(this, "aesEncryptionService", _BasisTheoryBrowserAesEncryptionService.BasisTheoryBrowserAesEncryptionService);

    _defineProperty(this, "providerKeyFactories", void 0);

    _defineProperty(this, "encryptionFactories", void 0);

    _defineProperty(this, "_defaultOptions", {
      keyRepository: _LocalStorageKeyRepository.localStorageKeyRepository,
      providerKeyRepository: _LocalStorageProviderKeyRepository.localStorageProviderKeyRepository,
      rsaKeySize: _constants.DEFAULT_RSA_SIZE
    });

    this.providerKeyFactories = [new _BrowserAesProviderKeyFactory.BrowserAesProviderKeyFactory(this._defaultOptions.providerKeyRepository, this._defaultOptions.keyRepository), new _BrowserRsaProviderKeyFactory.BrowserRsaProviderKeyFactory(this._defaultOptions.providerKeyRepository, this._defaultOptions.keyRepository, this._defaultOptions.rsaKeySize)];
    this.encryptionFactories = [new _BrowserAesEncryptionFactory.BrowserAesEncryptionFactory(this._defaultOptions.keyRepository), new _BrowserRsaEncryptionFactory.BrowserRsaEncryptionFactory(this._defaultOptions.keyRepository, this._defaultOptions.rsaKeySize)];
  }

  _createClass(BasisTheoryBrowserEncryptionProvider, [{
    key: "init",
    value: function init(_options) {
      var _initOptions = _objectSpread(_objectSpread({}, this._defaultOptions), _options);

      this.providerKeyFactories = [new _BrowserAesProviderKeyFactory.BrowserAesProviderKeyFactory(_initOptions.providerKeyRepository, _initOptions.keyRepository), new _BrowserRsaProviderKeyFactory.BrowserRsaProviderKeyFactory(_initOptions.providerKeyRepository, _initOptions.keyRepository, _initOptions.rsaKeySize)];
      this.encryptionFactories = [new _BrowserAesEncryptionFactory.BrowserAesEncryptionFactory(_initOptions.keyRepository), new _BrowserRsaEncryptionFactory.BrowserRsaEncryptionFactory(_initOptions.keyRepository, _initOptions.rsaKeySize)];
      return this;
    }
  }]);

  return BasisTheoryBrowserEncryptionProvider;
}();

exports.BasisTheoryBrowserEncryptionProvider = BasisTheoryBrowserEncryptionProvider;